import { _ as _createClass, a as _classCallCheck } from '../createClass-DV1OmW3s.js';
import { _ as _defineProperty } from '../defineProperty-DmV7cVMj.js';
import Logger from '../services/logger/index.js';
import LRUCacheNode from '../LRUNode/index.js';

var DEFAULT_SIZE = 10;
var LRU = /*#__PURE__*/function () {
  function LRU() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    _classCallCheck(this, LRU);
    _defineProperty(this, "limit", undefined);
    _defineProperty(this, "size", undefined);
    _defineProperty(this, "head", null);
    _defineProperty(this, "tail", null);
    _defineProperty(this, "cacheMap", undefined);
    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cacheMap = new Map();
  }
  return _createClass(LRU, [{
    key: "length",
    get: function get() {
      return this.size;
    }
  }, {
    key: "first",
    get: function get() {
      var _this$head;
      return (_this$head = this.head) === null || _this$head === undefined ? undefined : _this$head.value;
    }
  }, {
    key: "last",
    get: function get() {
      var _this$tail;
      return (_this$tail = this.tail) === null || _this$tail === undefined ? undefined : _this$tail.value;
    }
  }, {
    key: "keys",
    value: function keys() {
      return Array.from(this.cacheMap.keys());
    }
  }, {
    key: "values",
    value: function values() {
      return Array.from(this.cacheMap.values()).map(function (node) {
        return node.value;
      });
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.cacheMap.has(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var existingNode = this.cacheMap.get(key);
      if (existingNode) {
        this.detach(existingNode);
        this.size--;
      } else if (this.size === this.limit) {
        var _this$tail2;
        if ((_this$tail2 = this.tail) !== null && _this$tail2 !== undefined && _this$tail2.key) {
          this.cacheMap["delete"](this.tail.key);
          this.detach(this.tail);
        }
        this.size--;
      }
      if (!this.head) {
        // eslint-disable-next-line no-multi-assign
        this.head = this.tail = new LRUCacheNode(key, value);
      } else {
        var node = new LRUCacheNode(key, value, this.head);
        this.head.prev = node;
        this.head = node;
      }
      this.cacheMap.set(key, this.head);
      this.size++;
    }
  }, {
    key: "read",
    value: function read(key, withConsole) {
      var existingNode = this.cacheMap.get(key);
      if (existingNode) {
        var value = existingNode.value;
        if (this.head !== existingNode) {
          this.set(key, value);
        }
        return value;
      }
      Logger.info("Item not available in cache for key ".concat(key), withConsole);
    }
  }, {
    key: "detach",
    value: function detach(node) {
      if (node.prev !== null) {
        node.prev.next = node.next;
      } else {
        this.head = node.next;
      }
      if (node.next !== null) {
        node.next.prev = node.prev;
      } else {
        this.tail = node.prev;
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = null;
      this.tail = null;
      this.size = 0;
      this.cacheMap = new Map();
    }
  }]);
}();

export { LRU as default };
//# sourceMappingURL=index.js.map
